export interface UpdateSynonymGroupRequest {
  group: number
  data: string[]
  revision: number
}

export function UpdateSynonymGroupRequestToJSON(
  value: UpdateSynonymGroupRequest
): any {
  return {
    group: value.group !== 0 ? value.group : undefined,
    data: value.data.length > 0 ? value.data : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
